import axios from "axios";
import { toast } from "react-toastify";

const Api = axios.create({
  baseURL: "https://portal-api.mahanpanel.com ",
});

// Attach the access token to every outgoing request. This is registered on the
// default axios singleton (not just the `Api` instance) so it also covers the
// many pages that call `axios.get/post/...` directly with a full URL instead
// of importing `Api`.
const attachAuthToken = (config: any) => {
  const token = localStorage.getItem("app_at_mahan");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

axios.interceptors.request.use(attachAuthToken);
Api.interceptors.request.use(attachAuthToken);

// Function to refresh the access token
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("app_rt_mahan");
    if (!refreshToken) {
      throw new Error("Refresh token not found");
    }
    // Make sure to add the full URL if needed
    const response = await axios.post(
      "https://portal-api.mahanpanel.com/refresh-token",
      { app_rt_mahan: refreshToken },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    localStorage.setItem("app_at_mahan", response.data.app_at_mahan);
    toast.success("Token successfully refreshed");
    return response.data.app_at_mahan;
  } catch (error) {
    toast.error("نام کاربری یا رمز عبور اشتباه است");
    localStorage.clear();
  }
};
// Adding interceptor to handle the token refresh
Api.interceptors.response.use(
  async (response: any) => {
    if (response?.data?.refresh_token) {
      try {
        const res = await axios.post(
          `https://portal-api.mahanpanel.com/refresh-token?refresh_token=${response?.data?.refresh_token}`
        );
        if (res) {
          localStorage.setItem("app_at_mahan", res?.data.access_token);
          localStorage.setItem("app_rt_mahan", res.data.refresh_token);
        }
      } catch (err) {
        toast.error("مشکلی پیش امده لطفا مجدد وارد شوید");
        localStorage.removeItem("app_at_mahan");
        localStorage.removeItem("app_rt_mahan");
        console.error("Error getting new refresh token:", err);
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return Api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Adding interceptor to handle the token refresh
// Api.interceptors.response.use(
//   (response: any) => {
//     if (response?.data?.app_rt_mahan) {
//       await    axios.post(`https://portal-api.mahanpanel.com/refresh-token?app_rt_mahan=${response?.data.app_rt_mahan}`,).then(res => {
//         if(response?.data.app_rt_mahan){
//           localStorage.removeItem('app_at_mahan');
//           localStorage.setItem('app_at_mahan', res?.data.app_at_mahan);
//         }
//       }).catch(err => {
//         console.error('Error getting new refresh token:', err);
//       });
//     }
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const newAccessToken = await refreshAccessToken();
//         if (newAccessToken) {
//           originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
//           return Api(originalRequest); // Retry the request with the new access token
//         }
//       } catch (refreshError) {
//         console.error('Error refreshing token:', refreshError);
//         localStorage.clear();
//         window.location.href = '/login'; // Redirect to login if refresh fails
//       }
//     }
//     return Promise.reject(error);
//   }
// );

export default Api;

// import axios from 'axios';
// import { toast } from 'react-toastify';

// const Api = axios.create({
//   baseURL: 'https://portal-api.mahanpanel.com ',
// });

// // افزودن اینترسپتور برای رفرش توکن
// Api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 || !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const refreshToken = localStorage.getItem('app_rt_mahan');
//         const response = await axios.post('/refresh-token', { app_rt_mahan: refreshToken });
//         localStorage.setItem('app_at_mahan', response.data.app_at_mahan);
//         // افزودن توکن جدید و ارسال مجدد درخواست
//         originalRequest.headers['Authorization'] = `Bearer ${response?.data.app_at_mahan}`;
//         return Api(originalRequest);
//       } catch (refreshError) {
//         toast.error('نشست شما به پایان رسیده است، لطفا دوباره وارد شوید');
//         localStorage.removeItem('app_at_mahan');
//         localStorage.removeItem('app_rt_mahan');
//         window.location.href = '/login';
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default Api;
